import { SearchOutlined } from '@ant-design/icons';
import { ExportButton } from '@monorepo/shared-lib';
import { Radio, Space, Spin } from 'antd';
import { ReactComponent as IconExport } from 'assets/images/icons/iconExport.svg';
import { RoundInput } from 'components/Custom/inputs';
import React from 'react';
import { useSelector } from 'react-redux';
import { getCsvLoadingState } from 'store/vat/selectors';
import { usePwaMobileNavEnabled } from 'utils/usePwaMobileNavEnabled';
import { TransactionTableHeaderProps } from '../types/transaction.types';

export const TransactionTableHeader: React.FC<TransactionTableHeaderProps> = ({
  journalType,
  noSumData,
  summarizedStatusPending,
  onSearch,
  onJournalTypeChange,
  t,
  exportToCsv,
  itemLabel,
}) => {
  const csvLoading = useSelector(getCsvLoadingState);
  const resolvedItemLabel = itemLabel ?? t('organisation.transactions');
  const pwaMobileNav = usePwaMobileNavEnabled();

  return (
    <Space
      className={pwaMobileNav ? 'scope-pwa-vat-transactions-header' : undefined}
      style={{
        display: 'flex',
        marginBottom: 20,
        justifyContent: 'space-between',
      }}
    >
      <Space
        className={
          pwaMobileNav ? 'scope-pwa-vat-transactions-header__left' : undefined
        }
      >
        {!pwaMobileNav ? (
          <Radio.Group
            value={journalType}
            buttonStyle="solid"
            style={{ borderRadius: '10px' }}
            onChange={(e) => onJournalTypeChange?.(e.target.value)}
          >
            <Radio.Button value={'SUMMARISED'} disabled={noSumData}>
              <Space size={6}>
                {t('transactions.summarised')}
                {summarizedStatusPending && <Spin size="small" />}
              </Space>
            </Radio.Button>
            <Radio.Button value={'DETAILED'}>
              {t('transactions.detailed')}
            </Radio.Button>
          </Radio.Group>
        ) : null}

        {!pwaMobileNav ? (
          <ExportButton
            icon={<IconExport style={{ width: 20, height: 20 }} />}
            onClick={exportToCsv}
            loading={csvLoading}
          >
            <span>{`${t('common.export')} ${resolvedItemLabel}`}</span>
          </ExportButton>
        ) : null}
      </Space>

      <RoundInput
        className={
          pwaMobileNav ? 'scope-pwa-vat-transactions-header__search' : undefined
        }
        width={pwaMobileNav ? '100%' : '200px'}
        height={'35px'}
        prefix={<SearchOutlined />}
        size="large"
        placeholder={
          pwaMobileNav
            ? t('vat-report.search-contact-or-description')
            : `${t('common.search')} ${resolvedItemLabel}`
        }
        onChange={(e) => onSearch(e.target.value)}
      />
    </Space>
  );
};
